import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { useConversations } from '../../../../../hooks';
import { conversationShape } from '../../../../../types';
import { formatRelativeTime } from '../../../../../utils';
import Header from './Header';
import Tags from './Tags';

const ConversationTile = ({ conversation }) => {
  const { activeConversation, handleConversationClick: handleClick } = useConversations();

  const isActive = activeConversation.id === conversation.id;

  const containerStyles = cn(
    'flex flex-col gap-3 p-3 rounded-lg border hover:bg-accent duration-300',
    'cursor-pointer',
    isActive && 'bg-muted'
  );

  const {
    lastMessage: {
      content: message,
      createdAt: sentAt,
      isRead,
      sender: { fullName: senderName },
    },
    subject,
    tags,
  } = conversation;

  return (
    <div className={containerStyles} onClick={() => handleClick(conversation)}>
      <Header
        isRead={isRead}
        senderName={senderName}
        sentAgo={formatRelativeTime(sentAt)}
        subject={subject}
      />

      <p className="line-clamp-2 text-xs text-muted-foreground">{message}</p>
      <Tags tags={tags} />
    </div>
  );
};

ConversationTile.Skeleton = function () {
  return <Skeleton className="h-32 rounded-lg shrink-0" />;
};

ConversationTile.propTypes = {
  conversation: conversationShape.isRequired,
};

export default ConversationTile;
